// MARK: NPM Modules
import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
// MARK: Redux
import { setStyleguide } from "reduxFunctionality/slices/styleguide";
// MARK: Types
import ReduxStyleguideProps from "types/redux/styleguide";
import StyleguideProps from "types/globals/styleguide/styleguideProps";
// MARK: Functionality
import Colors from "enums/colors";
import getColors from "utils/styleguide/getColors";

const Styleguide = ({ styleguide, onStyleguideUpdate }: StyleguideProps) => {
  // Set Dispatch to be able to set the Redux Props
  const dispatch = useDispatch();

  useEffect(() => {
    // Update Properties
    updateProperties();
  }, [])

  // On Resize / Orientation Change, Update Properties
  useLayoutEffect(() => {
    window.addEventListener("resize", updateProperties);
    return () => {
      window.removeEventListener("resize", updateProperties);
    };
  }, []);

  const {
    maximumBodyWidth,
    maximumBlogWidth,
    colors,
    breakpointData
  } = styleguide;

  // Get the Current Breakpoint
  const getCurrentBreakpointDatSet = () => {
    const innerWidth = window.document.documentElement.clientWidth;

    var currentBreakpointDataset = breakpointData[0];
    var maximumBreakpoint = breakpointData.length - 1;

    breakpointData.forEach((dataset, index) => {
      if (index === maximumBreakpoint && innerWidth >= dataset.minimumWidth) {
        currentBreakpointDataset = breakpointData[index];
      } else if (
        innerWidth >= dataset.minimumWidth &&
        innerWidth <= dataset.maximumWidth
      ) {
        currentBreakpointDataset = breakpointData[index];
      }
    });

    return currentBreakpointDataset;
  };

  const updateProperties = async () => {
    // Get Window Dimensions & Determine if Portrait
    const innerWidth = typeof window === "undefined" ? 1440 : window.document.documentElement.clientWidth;
    const innerHeight = typeof window === "undefined" ? 1080 : window.document.documentElement.clientHeight;
    const isPortrait = innerWidth < innerHeight;
    // Get the current breakpoint dataset
    const currentBreakpointDataset = getCurrentBreakpointDatSet();
    // Determine Breakpoint specific data
    // console.log("currentBreakpointDataset : ", currentBreakpointDataset);

    const { breakpoint, margin, gutter } = currentBreakpointDataset;
    const currentBreakPoint = parseInt(breakpoint);
    // console.log("currentBreakPoint : ", currentBreakPoint);

    // Container Width
    const containerWidth =
      innerWidth > maximumBodyWidth
        ? maximumBodyWidth - 2 * margin
        : innerWidth - 2 * margin;

    // Mobile
    const mobile = currentBreakPoint < 2;

    // Typeset the Data
    const data: ReduxStyleguideProps = {
      colors: {
        primary: getColors(colors, Colors.primary),
        secondary: getColors(colors, Colors.secondary),
        tertiary: getColors(colors, Colors.tertiary),
        accent: getColors(colors, Colors.accent),
        background: getColors(colors, Colors.background),
        error: getColors(colors, Colors.error),
      },
      breakpoint: currentBreakPoint,
      isPortrait: isPortrait,
      mobile: mobile,
      innerWidth: innerWidth,
      innerHeight: innerHeight,
      maximumBodyWidth: maximumBodyWidth,
      maximumBlogWidth: maximumBlogWidth,
      containerWidth: containerWidth,
      margin: margin,
      gutter: gutter,
      navigationBarHeight: mobile ? 60 : 80,
    };
    // Set Redux
    dispatch(setStyleguide(data));
    // Callback
    onStyleguideUpdate();
  };
  return <div />;
};

export default Styleguide;
